import { render, staticRenderFns } from "./audiodetail.vue?vue&type=template&id=45eb16f2&scoped=true"
import script from "./audiodetail.vue?vue&type=script&lang=js"
export * from "./audiodetail.vue?vue&type=script&lang=js"
import style0 from "./audiodetail.vue?vue&type=style&index=0&id=45eb16f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45eb16f2",
  null
  
)

export default component.exports